import React, { useCallback, useRef } from "react";
import AsyncSelect from 'react-select/async';

function UserMultiSelect(props) {
  const debounceTimerRef = useRef(null);

  // Debounce the loadOptions to avoid excessive API calls
  const debouncedLoadOptions = useCallback((inputValue, callback) => {
    // Don't search if less than 3 characters
    if (!inputValue || inputValue.length < 3) {
      callback([]);
      return;
    }

    // Clear previous timeout
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    // Set new timeout
    debounceTimerRef.current = setTimeout(() => {
      if (props.loadOptions) {
        props.loadOptions(inputValue, callback);
      }
    }, 300); // 300ms debounce delay
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.loadOptions]);

  return (
    <>
      <AsyncSelect
        id='input-selected-user-emails'
        name={props.name}
        placeholder={ `${props.placeholder ?? ""} ${props.required === true ? ' *' : ''}` }
        className={ `${props.className ?? ""} custom-select-field-container` }
        classNamePrefix={ `${props.classNamePrefix} custom-select-field` }
        onChange={
          event => {
            if (props.onChange) {
              props.onChange( event );
            }
          }
        }
        isMulti
        cacheOptions
        defaultOptions={false}
        loadOptions={debouncedLoadOptions}
        defaultValue={props.defaultValue}
        menuPortalTarget={props.menuPortalTarget}
        menuPosition={props.menuPosition}
        menuPlacement={props.menuPlacement}
        styles={props.styles}
      />
    </>
  );
}

export { UserMultiSelect };
